"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.action('ON_QUICK_OPTION_TOGGLE', function (isToggledOn, option) { return ({
    isToggledOn: isToggledOn,
    option: option,
}); });
//# sourceMappingURL=onQuickOptionToggle.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/actions/owa-options-actions/lib/onQuickOptionToggle.js
// module id = 3773
// module chunks = 2